import { render, staticRenderFns } from "./PillBar.vue?vue&type=template&id=41143d2a&scoped=true&"
import script from "./PillBar.vue?vue&type=script&lang=js&"
export * from "./PillBar.vue?vue&type=script&lang=js&"
import style0 from "./PillBar.vue?vue&type=style&index=0&id=41143d2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41143d2a",
  null
  
)

export default component.exports